import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import SettingsMenu from "./SettingsMenu";
import SettingsPage from "../../pages/settings/[[...params]]";
import constants from "../../utils/constants";
import { useEffect, useState } from "react";
import { getIsOnpremise } from "../../utils";
var SettingsModal = function SettingsModal() {
  var _useState = useState(constants.SETTINGS.NOTIFICATIONS),
    selectedPage = _useState[0],
    setSelectedPage = _useState[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isVisible: s.isSettingsOpen,
        hasUnsavedSetting: s.hasUnsavedSetting,
        selectedSetting: s.selectedSetting
      };
    }),
    isVisible = _useStoreState.isVisible,
    hasUnsavedSetting = _useStoreState.hasUnsavedSetting,
    selectedSetting = _useStoreState.selectedSetting;
  var isOnpremise = getIsOnpremise();
  useEffect(function () {
    if (isOnpremise) {
      setSelectedPage(constants.SETTINGS.REMOTE_ACCESS);
    }
  }, [isOnpremise]);
  useEffect(function () {
    if (selectedSetting) {
      setSelectedPage(selectedSetting);
    }
  }, [selectedSetting]);
  var onCloseModal = function onCloseModal() {
    Store.update(function (s) {
      s.isSettingsOpen = false;
    });
  };
  var onLogout = function onLogout() {
    Store.update(function (s) {
      s.isLogoutOpen = true;
    });
  };
  var onChangeSetting = function onChangeSetting(pageName) {
    if (hasUnsavedSetting) {
      Store.update(function (s) {
        s.showUnsavedWarning = true;
      });
    } else {
      Store.update(function (s) {
        s.selectedSetting = pageName;
      });
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    className: "flex w-full !bg-gray-900 border-0 sm:w-10/12 md:w-full lg:w-8/12 h-4/5 overflow-hidden"
  }, /*#__PURE__*/React.createElement(SettingsMenu, {
    onLogout: onLogout,
    onClose: onCloseModal,
    onChange: onChangeSetting,
    selected: selectedPage
  }), /*#__PURE__*/React.createElement(SettingsPage, {
    pageName: selectedPage,
    onChangeSetting: onChangeSetting
  }));
};
export default SettingsModal;